import loadPage from '../pages.js';

export default function landingPage() {
	if (document.getElementById('landingOrderForm')) {
		loadPage('order', '#landingOrderForm');
	}
};
